import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { ADD_BUNDLE_PRODUCT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class AddBundleProduct extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = ADD_BUNDLE_PRODUCT_URL;

  constructor(applicationId, bundleProductId, demandProductId) {
    super();

    this.body = {
      bundleProductId,
      parameters: {
        linkDebitCardToDemandProductId: demandProductId,
      },
    };
    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
